import * as Constants from 'components/landing/constants';

import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import SelectorItem from './item';
import styles from 'styles/LandingSelectorInsuranceTable.module.scss';
import Text from 'core/text';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import ViewMoreWrapper from 'components/landing/view-more-wrapper/wrapper';

const InsuranceCompanySelectorTable = ({ data, culture }) => {
    const t = useTranslations('table.insurance-company-selector');
    const [viewMoreDisable, setViewMoreDisable] = useState(false);
    const { seoText, verification } =
        useGetSeoTextByIndex('insurance_company');

    useCustomMediaQuery(Constants.MEDIA_QUERIES.LG, (e) => {
        setViewMoreDisable(e.matches);
    });

    if (!data || !culture || !verification) {
        return null;
    }

    const duplicated = Constants.INSURANCE_DUPLICATED_LIST[culture] || null;

    return (
        <LandingSection className={styles.section}>
            <h2>{t('title')}</h2>
            <Text content={`${seoText.paragraph1.sentence1} ${seoText.paragraph1.sentence2} ${seoText.paragraph1.sentence3}`} />
            <Text content={`${seoText.paragraph2.sentence1} ${seoText.paragraph2.sentence2} ${seoText.paragraph2.sentence3} ${seoText.paragraph2.sentence4}`} />
            <Text content={`${seoText.paragraph3.sentence1}`} />
            <ViewMoreWrapper
                className={styles.items_wrapper}
                initialItems={10}
                itemsDelta={10}
                disabled={viewMoreDisable}
            >
                {data.map((item, index) => {
                    if (
                        duplicated !== null &&
                        duplicated.includes(item.company_code)
                    ) {
                        return null;
                    }
                    return (
                        <SelectorItem
                            culture={culture}
                            key={item.company_code + index}
                            companyCode={item.company_code}
                            companyName={item.company_name}
                            href={item.link}
                        />
                    );
                })}
            </ViewMoreWrapper>
        </LandingSection>
    );
};

InsuranceCompanySelectorTable.propTypes = {
    data: PropTypes.array,
    culture: PropTypes.string
};

export default InsuranceCompanySelectorTable;
